/**
 * True when an error is Clerk's `ClerkOfflineError`, thrown by
 * `session.getToken()` when the client is offline (Clerk v6 throws where v5
 * returned `null`).
 *
 * Matches on the error code rather than `instanceof` — the same strategy as
 * Clerk's own `ClerkOfflineError.is()` — so it works across bundles/realms.
 * We avoid importing the class from `@clerk/react/errors` because that
 * subpath's types are unresolvable under this project's `moduleResolution:
 * "node"` setting.
 */
export const isClerkOfflineError = (error: unknown): boolean =>
  error instanceof Error && 'code' in error && error.code === 'clerk_offline';
